export enum PfrRowOutlineColor {
    "success" = "success",
    "error" = "error"
}